import { nsSig } from '../img/ns-sig'

export const formS1778 = (): any[] => [
    {
        text: 'Thank you for your recent request to opt out of the sharing of your personal information, as permitted under the California Consumer Privacy Act.',
        marginBottom: 10
    },
    {
        text: 'SAFE only shares personal information of consumers with other businesses or third parties to fulfill requests to process sweepstakes and contest entries or manage subscriptions to our blog and/or newsletter. Therefore, consumers are not provided the opportunity to opt out.',
        marginBottom: 10
    },
    {
        text: [
            { text: 'Rest assured, SAFE is committed to maintaining strong privacy programs that adhere to strict data privacy and security requirements. To learn more, please visit ' },
            { text: 'safecu.org/privacy. ', bold: true },
        ],
        marginBottom: 10
    },
    {
        text: 'If you have any questions, please feel free to contact a helpful SAFE representative at'
    },
    {
        text: [
            { text: '(916) 979-7233 ', bold: true },
            { text: 'or ' },
            { text: '(800) SEE-SAFE.', bold: true }
        ],
        marginBottom: 10
    },
    { text: 'Sincerely,', marginBottom: 5, marginTop: 10 },
    { image: nsSig, width: 140, marginBottom: 5 },
    { text: 'Nicole Smith' },
    { text: 'VP, Contact Center' },
    { text: 'SAFE Credit Union' }
]
